export const getBadgeType = (item, user) => {
    const hasAccess = item?.hasAccess || user?.isAdmin
    const isFree = !item?.minimumPrice
    const isPurchasedEvent = !!item?.challengeAthleteId

    let badgeType: undefined | 'free' | 'membersOnly' = undefined
    if (!isPurchasedEvent) {
        if (!hasAccess) {
            badgeType = 'membersOnly'
        } else if (isFree && !user) {
            badgeType = 'free'
        }

        // else if (isDiscounted) {
        //     badgeType = 'discount';
        //     badgeText = `${discountValueString} Off`;
        // } else if (isPremium) {
        //     badgeType = 'premium';
        //     badgeText = premiumPrice;
        // }
    }

    return badgeType
}

// no way to derive if a challenge is free or not other than has Access
export const getChallengeBadgeType = (item, user) => {
    const hasAccess = item?.hasAccess || user?.isAdmin
    const isPurchasedEvent = !!item?.challengeAthleteId

    let badgeType: undefined | 'free' | 'membersOnly' = undefined
    if (!isPurchasedEvent) {
        if (!hasAccess) {
            badgeType = 'membersOnly'
        } else if (!user) {
            badgeType = 'free'
        }
    }

    return badgeType
}
